<script>
import { generate } from 'randomstring';

import IconChevronDown from '../icons/IconChevronDown';

export default {
  components: {
    IconChevronDown,
  },
  props: {
    label: String,
    hideLabel: [Boolean, String],
    labelLarge: [Boolean, String],
    optional: [Boolean, String],
    value: [String, Number],
    disabled: Boolean,
    error: String,
    errorVisible: Boolean,
    type: String,
    id: String,
  },
  computed: {
    classes() {
      let classes;

      if (this.type === 'footer') {
        classes = 'border-brand-secondary-800 text-brand-secondary-400';
      } else if (this.type === 'sales') {
        classes = `border-border text-brand-secondary${this.value ? '' : '-100'}`;
      } else {
        classes = `border-brand-secondary-200 text-brand-secondary${this.value ? '' : '-100'} focus_outline-none focus_border-brand-secondary-400`;
      }

      return classes;
    },
    errorId() {
      return generate();
    },
    chevronClass() {
      let chevronClass;

      if (this.type === 'footer') {
        chevronClass = 'text-brand-secondary-200';
      } else if (this.type === 'sales') {
        chevronClass = 'text-brand-secondary';
      } else {
        chevronClass = 'text-brand';
      }

      return chevronClass;
    },
  },
};
</script>

<template lang='pug'>
.text-left.buyer-select
  label.text-brand-secondary(
    v-if='label && !hideLabel',
    :class='[type === "sales" ? "font-bold mb-_5 block md_text-sm" : null, { "text-xl md_text-base": labelLarge }]',
  ) {{label}} #[span.text-brand-secondary-100(v-if='optional') (optional)]
  .relative
    select.relative.z-20.rounded-none.appearance-none.bg-transparent.border.text-xl.md_text-base.py-1.md_py-_75.pl-1.pr-2.w-full.cursor-pointer.disabled_opacity-50.disabled_cursor-not-allowed(
      :id='id',
      :value='value',
      :class='classes',
      :aria-label='label',
      :aria-describedby='error && errorVisible ? errorId : null',
      :aria-invalid='error && errorVisible ? "true" : "false"',
      :aria-disabled='disabled ? "true" : "false"',
      :disabled='disabled',
      @change='$emit("input", $event)',
    )
      slot
    icon-chevron-down.absolute.absolute--center-vertical.right-1.z-10(
      :class='chevronClass',
    )
    .absolute.top-0.left-0.h-full.w-full.z-0(:class='type === "footer" ? "bg-transparent" : "bg-white"')
  .mt-_5.text-error.text-sm(
    v-if='error && errorVisible',
    :id='errorId',
  ) {{error}}
</template>

<style scoped>
@import '~import/index';

select>option {
  color: black;
}
</style>